module.exports = __webpack_public_path__ + "img/e4911.d4859775.svg";